import { render, staticRenderFns } from "./BasePageination.vue?vue&type=template&id=1e986e8b"
import script from "./BasePageination.vue?vue&type=script&lang=js"
export * from "./BasePageination.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_857a25aa4406afef410ce4b662efafed/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports